import React from 'react';
import ApplicationFormContext from './ApplicationFormContext';
const useApplicationForm = () => {
    const applicationForm = React.useContext(ApplicationFormContext);
    if (!applicationForm) {
        throw new Error('useApplicationForm must be used inside of a <Form> component');
    }
    return applicationForm;
};
export default useApplicationForm;
